if (!customElements.get('cabanel-personnalisation')) {
  customElements.define(
    'cabanel-personnalisation',
    class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.form = this.closest('form');
        this.input = this.querySelector('[data-cabanel-input]');
        this.error = this.querySelector('[data-cabanel-error]');
        this.variantInput = this.form?.querySelector('[name="id"]');
        const data = this.querySelector('[data-cabanel-variants]');

        if (!this.form || !this.input || !this.variantInput || !data) {
          return;
        }

        this.variants = JSON.parse(data.textContent);
        this.controller = new AbortController();
        const signal = this.controller.signal;

        this.variantInput.addEventListener(
          'change',
          () => this.syncVariant(),
          { signal }
        );

        this.input.addEventListener(
          'input',
          () => {
            this.input.setCustomValidity('');
            this.input.removeAttribute('aria-invalid');
            this.error.hidden = true;
          },
          { signal }
        );

        this.form.addEventListener(
          'submit',
          (event) => {
            this.syncVariant();
            if (!this.active) return;

            const value = this.input.value.normalize('NFC').trim();
            const allowed = /^[A-Za-z0-9 ]+$/;

            let message = '';

            if (!value) {
message = 'Veuillez renseigner votre personnalisation.';
            } else if (value.length > 12) {
              message = 'Votre personnalisation doit contenir au maximum 12 caractères.';
            } else if (!allowed.test(value)) {
message = 'Utilisez uniquement des lettres sans accent, des chiffres et des espaces.';
            }

            if (message) {
              event.preventDefault();
              event.stopImmediatePropagation();

              this.input.setCustomValidity(message);
              this.input.setAttribute('aria-invalid', 'true');
              this.error.textContent = message;
              this.error.hidden = false;
              this.input.focus();
              return;
            }

            this.input.value = value;
            this.input.setCustomValidity('');
            this.input.removeAttribute('aria-invalid');
            this.error.hidden = true;
          },
          { capture: true, signal }
        );

        this.observer = new MutationObserver(() => this.syncVariant());
        this.observer.observe(this.variantInput, {
          attributes: true,
          attributeFilter: ['value']
        });

        this.syncVariant();
      }

      syncVariant() {
        const variant = this.variants.find(
          (item) => item.id === String(this.variantInput.value)
        );

        this.active = Boolean(variant?.personalisation);
        this.hidden = !this.active;
        this.input.disabled = !this.active;
        this.input.required = this.active;

        if (!this.active) {
          this.input.value = '';
          this.input.setCustomValidity('');
          this.input.removeAttribute('aria-invalid');
          this.error.hidden = true;
        }

        // Évite de contourner la validation par l'achat accéléré.
        const paymentButton = this.form.querySelector(
          '.shopify-payment-button'
        );

        if (paymentButton) {
          if (this.active && !this.paymentState) {
            this.paymentState = {
              element: paymentButton,
              display: paymentButton.style.getPropertyValue('display'),
              priority: paymentButton.style.getPropertyPriority('display')
            };
            paymentButton.style.setProperty('display', 'none', 'important');
          } else if (!this.active) {
            this.restorePaymentButton();
          }
        }
      }

      restorePaymentButton() {
        if (!this.paymentState) return;

        const { element, display, priority } = this.paymentState;

        if (display) {
          element.style.setProperty('display', display, priority);
        } else {
          element.style.removeProperty('display');
        }

        this.paymentState = null;
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.restorePaymentButton();
        this.controller = null;
      }
    }
  );
}
